import React, { JSX } from "react";
import SkillsCard from "./SkillsCard";

type SkillSectionProps = {
  title: string;
  skills?: string[];
  langList?: {
    name: string;
    icon: JSX.Element;
    iconType: string;
    color: string;
  }[];
  img: string;
  order?: "list-first" | "img-first";
};

const SkillSection = ({
  skills,
  title,
  img,
  langList,
  order = "list-first",
}: SkillSectionProps) => {
  return (
    <div
      className="md:flex justify-evenly "
      style={{
        flexDirection: order === "list-first" ? "row" : "row-reverse",
      }}
    >
      <div className="flex md:w-[50%]">
        {" "}
        <SkillsCard skills={skills} title={title} langList={langList} />
      </div>
      <div className="flex p-2  md:w-[50%]">
        <img src={img} alt={title} className="w-full h-full" />
      </div>
    </div>
  );
};

export default SkillSection;
